"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectFastenersExistence = exports.selectDefaultFasteners = void 0;
/* eslint-disable import/prefer-default-export */
const reselect_1 = require("reselect");
exports.selectDefaultFasteners = (0, reselect_1.createSelector)((state) => state.defaultFasteners, (fasteners) => fasteners);
exports.selectFastenersExistence = (0, reselect_1.createSelector)((state) => state.defaultFasteners, (defaultFasteners) => defaultFasteners.fastenersExistence);
